<template>
  <div class="conten" :style="backgroundStyle">
    <div class="top-h2">
      <div class="box-top">
        <div class="detail" @click="goAbout()">查看选手列表</div>

        <!-- <div class="title">评委打分</div> -->
        <h2 style="width: 10%"></h2>

        <div class="detail" @click="goleft()">查看排行榜</div>
      </div>
    </div>
    <div
      style="
        position: relative;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 74%;
        min-width: 840px;
        height: 70%;
        margin: auto;
      "
    >
      <div class="box">
        <div class="topbox">
          <div class="marks" style="margin-left: 100px">
            <span style="font-size: 50px; font-weight: 600">最终得分:</span
            ><span style="font-size: 50px; font-weight: 600">{{
              currentData.score
            }}</span>
          </div>
        </div>
        <div
          style="display: flex; align-items: center; justify-content: center"
        >
          <div class="center" v-if="currentData != undefined">
            <div class="player-card1" style="">
              <div class="avatar">
                <el-image :src="baseurl + currentData.userimg" fit="fill">
                  <template slot="error">
                    <el-image
                      src="https://pfhd.hnzsnetwork.cn/static/images/screen/livemark/default.png"
                      fit="fill"
                    />
                  </template>
                </el-image>
              </div>
              <div class="player-info">
                <span style="font-size: 30px">{{ currentData.username }}</span>
                <!-- <div class="marks">
                  <span style="font-size: 12px">最终得分:</span
                  ><span style="font-size: 30px">{{ currentData.score }}</span>
                </div> -->
              </div>
            </div>
          </div>
          <div
            style="display: flex; justify-content: center; align-items: center"
          >
            <div class="content" style="overflow: auto">
              <div
                class="player-card"
                v-for="item in rotateAllPw"
                :key="item.id"
                style="height: 10vh; display: flex; align-items: center"
              >
                <!-- <div class="avatar">
                <el-image :src="baseurl + item.pwimg" fit="fill">
                  <template slot="error">
                    <el-image
                      src="https://pfhd.hnzsnetwork.cn/static/images/screen/livemark/default.png"
                      fit="fill"
                    />
                  </template>
                </el-image>
              </div> -->
                <div class="player-info">
                  <div class="marks">
                    <span
                      style="font-size: 12px"
                      v-show="item.totalscore == undefined ? true : false"
                      >评分中:</span
                    >
                    <span
                      style="font-size: 40px; font-weight: 600"
                      :class="item.totalscore == undefined ? 'loading' : ''"
                      >{{ item.totalscore }}</span
                    >
                  </div>
                  <span style="font-size: 20px; font-weight: 400">{{
                    item.pwname
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getconfiglivemarkList } from "@/utils/http.js";
export default {
  data() {
    return {
      livemarkRecord: [],
      rotateAllPw: [],
      currentData: undefined,
      timer: "",

      huodongId: this.$route.query.huodongId,
      bgimg: "", //背景图片
      baseurl: "https://xileqiniuzdy.hnzsnetwork.cn/",
    };
  },
  created() {
    this.getData();
    this.setTimer();
    getconfiglivemarkList({ huodongId: this.huodongId }).then((res) => {
      this.bgimg = this.baseurl + res.rows[0].bgimg;
    });
  },
  computed: {
    ...mapGetters(["huodongData", "title"]),
    backgroundStyle() {
      console.log("this.bgimg", this.bgimg);
      return {
        backgroundImage: `url(${this.bgimg})`,
        // 其他样式
      };
    },
  },
  methods: {
    getData() {
      const data = JSON.parse(localStorage.getItem("huodongData"));
      this.currentData = data.find((item) => {
        if (Number(item.id) === Number(this.$route.query.id)) return item;
      });
      this.livemarkRecord = this.currentData.livemarkRecord;
      let rotateAllPw = this.currentData.rotateAllPw;
      if (rotateAllPw != null && this.livemarkRecord != null) {
        rotateAllPw.forEach((element, index) => {
          let record = this.livemarkRecord.find((item) => {
            if (Number(item.pwid) === Number(element.id)) return item;
          });
          console.log("record", record);
          if (record != undefined) {
            rotateAllPw[index].totalscore = record.totalscore;
          } else {
            rotateAllPw[index].totalscore = undefined;
          }
        });
      }

      this.rotateAllPw = rotateAllPw;
    },
    setTimer() {
      this.clearTimer();
      this.timer = setInterval(() => {
        setTimeout(() => {
          this.$store.dispatch("GethuodongData", {
            huodongId: this.$route.query.huodongId,
            sortPara: "",
          });
        }, 0);
        this.getData();
      }, 5000);
    },
    clearTimer() {
      this.timer && clearInterval(this.timer);
    },
    goAbout() {
      this.$router.push({
        name: "About",
        query: { huodongId: this.$route.query.huodongId },
      });
    },
    goleft() {
      this.$router.push({
        name: "livemark",
        query: { huodongId: this.$route.query.huodongId },
      });
    },
    goqieh(val) {
      this.qieh = val;
    },
  },
  beforeDestroy() {
    this.clearTimer();
  },
};
</script>

<style lang="less" scoped>
@keyframes dot {
  0% {
    content: "...";
  }
  50% {
    content: ".";
  }
  75% {
    content: "..";
  }
  100% {
    content: "...";
  }
}
.loading:after {
  content: "";
  animation: dot 2s infinite;
}
.conten {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
}

::v-deep .el-switch {
  width: 86px;
}

::v-deep .el-switch__label {
  position: absolute;
  display: none;
  color: #fff;
}

/*打开时文字位置设置*/
::v-deep .el-switch__label--right {
  z-index: 1;
  right: 19px;
}

/*关闭时文字位置设置*/
::v-deep .el-switch__label--left {
  z-index: 1;
  left: 40px;
}

/*显示文字*/
::v-deep .el-switch__label.is-active {
  display: block;
}

::v-deep .el-switch .el-switch__core {
  width: 86px !important;
}

::v-deep .el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 55px;
}

.footer {
  width: 198px;
  color: #fff;
  position: absolute;
  right: 15px;
  bottom: -37px;
}

.top-h2 {
  display: flex;
  justify-items: center;
  align-items: center;
  width: 100%;
  height: 20%;
}

.box-top {
  display: flex;
  align-items: flex-end;
  height: 50px;
  width: 100%;
  justify-content: space-between;
  padding-left: 65px;
  padding-right: 50px;
  margin: 0 auto;

  .detail {
    color: #fff;
    border: 1px solid #fff;
    text-align: center;
    width: 180px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    border-radius: 17px;
    cursor: pointer;

    &.active {
      background-color: rgb(161, 122, 166);
    }
  }
}

.box {
  // background: #12293e80;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
  border-radius: 4px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  // border: 1px solid red;
  .topbox {
    display: flex;
    justify-content: center;
    color: #fff;
    // border-radius: 10px;
    // background: rgba(0, 0, 0, 0.7);
  }
}

.center {
  //height: 40%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  //margin: 0 auto;
  margin-right: 40px;
  // margin-top: 20px;

  .image {
    width: 80px;
    height: 100%;
    border-radius: 4px;
    background-image: url(../assets/tx.png);
    background-size: 100% 100%;
  }

  .top-right {
    height: 1005;

    .span {
      color: #036eb8;
    }

    .span1 {
      color: #036eb8;
      font-size: 32px;
      font-weight: 600;
    }

    .top-title {
      font-size: 14px;
      color: #fff;
    }
  }
}

.content {
  display: flex;
  flex-wrap: wrap;
  width: 800px;
  margin-top: 10px;
  justify-content: space-around;
  // margin-top: 40px;
  padding: 13px 0;

  .content-item {
    width: 16%;
    height: 180px;
    display: grid;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    background-color: #aab3d7;
    font-size: 38px;
    border: 2px solid transparent;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    cursor: pointer;

    .background-Image {
      width: 100px;
      height: 100px;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      border-radius: 8px;
    }

    .content-right {
      width: 100%;
      height: 100%;
      /* margin-top: 15px; */
      text-align: center;

      .title-top {
        color: #036eb8;
        font-size: 18px;
      }

      .title-bottom {
        color: #036eb8;
        font-size: 16px;
        margin-top: 8px;
      }
    }
  }
}

// ---------------
.box-top {
  padding-top: 75px;
  position: relative;

  .title {
    position: absolute;
    top: 30px;
    left: 50%;
    font-size: 34px;
    color: #fff;
    font-weight: 600;
    transform: translateX(-50%);
  }
}
</style>
